import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import Cookies from 'js-cookie';
import { UserLogin, UserInfo } from '@/models/user';
import sleep from '@/utils/sleep';
import getCookieName from '@/utils/cookie';
import { getRoleById } from '@/utils/role';

const DEFAULT_USER: UserInfo = {
  id: null,
  name: null,
  role: null,
  projectId: null,
};

@Module({ namespaced: true, name: 'user' })
export default class UserModule extends VuexModule {
  public token: string | null = Cookies.get(getCookieName('token')) || null;

  public user: UserInfo = Cookies.get(getCookieName('admin')) ? JSON.parse(Cookies.get(getCookieName('admin')) as string) : DEFAULT_USER;

  get isLogin() {
    return this.token !== null;
  }

  get isRoot() {
    return this.isLogin && this.user.role === 1;
  }

  get isAdmin() {
    return this.isLogin && this.user.role === 2;
  }

  get isStaff() {
    return this.isLogin && this.user.role === 3;
  }

  get getRoleId() {
    return this.isLogin ? this.user.role : null;
  }

  get getUserRole() {
    return this.isLogin ? getRoleById(this.user.role as number) : null;
  }

  get currentUser(): UserInfo | null {
    return this.isLogin ? {
      ...this.user,
      role: this.getUserRole,
    } : null;
  }

  get getToken() {
    return this.isLogin ? this.token : null;
  }

  @Mutation
  public setUser(userInfo: UserLogin) {
    this.token = userInfo.token;

    this.user.id = userInfo.id;
    this.user.name = userInfo.name;
    this.user.role = userInfo.role;
    this.user.projectId = userInfo.projectId;
  }

  @Mutation
  public updateToken(token: string) {
    this.token = token;
  }

  @Mutation
  public clearUser() {
    this.token = null;

    this.user = DEFAULT_USER;
  }

  @Action
  // eslint-disable-next-line class-methods-use-this
  public async syncLoginInfoInCookie() {
    try {
      await sleep(1);
    } catch (error) {
      console.error(error);
    }
  }
}
